import Table from 'common/table/table';
import { ThemeHeader } from 'common/table/table-helper';
import { Toolbar } from 'common/toolbar';
import sortBy from 'lodash.sortby';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Button, SapId } from 'ui';
import { withRouter } from 'utils/withRouter';
import PermissionCheck from '../../features/permission-check';

const Wrapper = styled.div`
  background-color: #fff;
`;

const ServicesTable = ({ isLoading, services, intl, history, activeRow }) => {
  const [selectedService, setSelectedService] = useState();

  const getColumns = () => {
    const { formatMessage: translate } = intl;

    return [
      {
        displayName: translate({ id: 'dashboard.servicesTable.TYPE_COL' }),
        fieldName: 'type',
      },
      {
        displayName: translate({ id: 'dashboard.servicesTable.DESCRIPTION_COL' }),
        fieldName: 'description',
        tooltip: row => row.description,
      },
      {
        displayName: translate({ id: 'dashboard.servicesTable.SERIAL_COL' }),
        fieldName: 'serialNumber',
      },
      {
        displayName: translate({ id: 'dashboard.servicesTable.EQUIPMENT_ID_COL' }),
        renderFn: row => <SapId originalId={row.number}>{id => <>{id}</>}</SapId>,
      },
      {
        displayName: translate({ id: 'dashboard.servicesTable.CONTRACT_COL' }),
        fieldName: 'contractIndicator',
      },
      {
        displayName: translate({ id: 'dashboard.servicesTable.CONTRACT_END_DATE_COL' }),
        renderFn: v => v?.contractEndDate && intl.formatDate(v?.contractEndDate),
      },
    ];
  };

  const handleRowSelect = (v) => {
    if (selectedService && selectedService === v) {
      setSelectedService();
    } else {
      setSelectedService(v);
    }
  };

  const handleRowClick = ({ id }) => {
    if (id) {
      history.push(`/equipment/${id}`, { context: id });
    }
  };

  const handleCreateOrderClick = () => {
    history.push(`create-order/equipment/${selectedService}`);
  };

  // TODO: Remove eslint disable once bug 6680 is solved and the function is used
  // eslint-disable-next-line no-unused-vars
  const renderToolbar = () =>
    <PermissionCheck permissionsList={['ordercreate']}>
      <Toolbar>
        <Toolbar.Item showAsQuickAccess={true}>
          <Button
            type='secondary'
            dark
            onClick={handleCreateOrderClick}
            disabled={!selectedService}
          >
            <FormattedMessage id='dashboard.CREATE_ORDER_BTN' />
          </Button>
        </Toolbar.Item>
      </Toolbar>
    </PermissionCheck>;
  const selectedRowKeys = selectedService ? [selectedService] : [];
  const sortedServices = sortBy(services, [
    s => !s.number && !s.contractIndicator,
    'type',
    'description',
  ]);

  const renderHeader = () => <ThemeHeader inlineTable={true} height='50px'>
    <span>
      {`${intl.formatMessage({ id: 'dashboard.servicesTable.TABLE_TITLE' })} `}
      ({services?.length})
    </span>
  </ThemeHeader>;

  return (
    <Wrapper data-test-id='services'>
      <Table
        renderCustomHeader={renderHeader}
        fullWidth={true}
        // TODO: Put this back and adjust once bug 6680 is solved in BE
        // toolbar={renderToolbar()}
        columns={getColumns()}
        data={sortedServices}
        isLoading={isLoading}
        selectedRowIds={selectedRowKeys}
        onRowSelect={handleRowSelect}
        onRowClick={handleRowClick}
        activeRow={activeRow}
        lightHeader={true}
        usePaging={true}
      />
    </Wrapper>
  );
};

ServicesTable.propTypes = {
  isLoading: PropTypes.bool,
  services: PropTypes.array,
  intl: PropTypes.object,
  history: PropTypes.object.isRequired,
  activeRow: PropTypes.object,
};

export default withRouter(injectIntl(ServicesTable));
